import { useState, useRef, useEffect } from "react";
import { Image, Header, Placeholder } from "semantic-ui-react";

export default function HeadDetais(props) {
  const imgRef = useRef(null);
  const [state, setState] = useState(false);

  const onImageLoaded = () => setState(true);

  useEffect(() => {
    const imgElCurrent = imgRef.current;

    if (imgElCurrent) {
      imgElCurrent.addEventListener("load", onImageLoaded);
      return () => imgElCurrent.removeEventListener("load", onImageLoaded);
    }
  }, [imgRef]);

  const { name, email,  photo, domain, animation } = props; //number,
  return (
    <div data-aos={animation} className={"head-details"}>
      <Placeholder style={{ display: state ? "none" : "block" }}>
        <Placeholder.Image
          as={"img"}
          style={{ display: state ? "none" : "block" }}
          className={"head-photo"}
        />
      </Placeholder>

      <Image
        onLoad={onImageLoaded}
        src={photo}
        circular={true}
        className={"head-photo"}
        style={{ display: state ? "block" : "none" }}
      />
      <div className={"head-detail-section"}>
        <Header className={"domain"} as={"h3"}>
          {domain ? `Head of ${domain}` : "Overall Head"}
        </Header>
        <p className={"name"}>{name}</p>
        <div className={"contact-details"}>
          {/*<p className={'number'}>{number}</p>*/}
          <p className={"head-email"}>{email}</p>
        </div>
      </div>
    </div>
  );
}
